import _ from "lodash";

export const formatCurrency = (value) => {
    let formatOptions = {
        style: 'currency',
        currency: 'BRL'
    }

    let formattedValue = value.toLocaleString('pt-BR', formatOptions)

    return formattedValue
}

export function findUndefined(object, param) {
    // console.log('findUndefined param', param)
    param = param || ""
    if (object === undefined) {
        console.log('findUndefined: ', param)
    } else {

        if (object && _.isObject(object)) {
            for (const key in object) {
                if (Object.hasOwnProperty.call(object, key)) {
                    const element = object[key];
                    findUndefined(element, param + "." + key)
                }
            }
        }
    }

}

/**
 * Limpa valores do objeto mantendo somente chaves do array
  * (apenas no primeiro nível).
 */
export function clearAtributes(object, param, fieldsMantem) {
    if (object) {
        const clearObj = _.get(object, param);

        if (_.isObject(clearObj) && !_.isArray(clearObj)) {
            for (const key in clearObj) {
                if (!fieldsMantem.includes(key)) {
                    delete clearObj[key];
                }
            }
        } else {
            // console.log(`Expected an object at path '${param}', but got:`, clearObj);
        }
    }
}

export const clearUndefinedProps = (obj) => {
    if (typeof obj !== "object" || obj === null) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj
            .filter((item) => typeof item !== "undefined")
            .map(clearUndefinedProps);
    }

    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (typeof value !== "undefined") {
            acc[key] = clearUndefinedProps(value);
        }
        return acc;
    }, {});
};